import React from "react";
import { useBreakpoint } from "../../hooks/useBreakpoint";

import CollapsibleWrapper from "../../components/shared/collapsibleWrapper";
import Image from "../../components/image";

const CourseExpert = ({
  featuredImage,
  sourceUrl,
  title,
  instructorRole,
  content
}) => {
  const breakpoint = useBreakpoint();
  return (
    <div className="flex flex-col md:flex-row justify-between gap-10 md:gap-11">
      <div className="rounded-full h-[48vw] md:h-[16vw] w-[48vw] md:w-[16vw] shrink-0 overflow-hidden">
        <Image
          image={featuredImage}
          imageAlt={title}
          sourceUrl={sourceUrl}
          imageClass={"h-full w-full object-cover"}
        />
      </div>
      <div className="md:pt-3 divide-y divide-scroll-light planet:divide-gray-light">
        <div>
          <div
            className="h3 !font-normal planet:!font-bold mb-4 md:mb-2"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <div
            className="pr-10 sm:pr-0 md:w-2/3 pb-4 md:pb-5 text-black-lighter planet:text-gray-generic text-mob md:text-base"
            dangerouslySetInnerHTML={{ __html: instructorRole }}
          />
        </div>
        <div>
          <CollapsibleWrapper
            desc={content}
            descStyle="pr-10 pt-4 sm:pr-0 text-black-lighter planet:text-white text-mob md:text-base"
            btnStyle="underline underline-offset-2 pt-3 md:hidden text-gray-generic text-mob"
            visibleLength={breakpoint === "xs" ? 350 : 70}
            readMoreAdditionalStyle={"md:line-clamp-none"}
            type={"mobile-only"}
            displayFullDesc={breakpoint !== "xs"}
          />
        </div>
      </div>
    </div>
  );
};

export default CourseExpert;
